const emptyOrderPayload = () => ({
  order_current_status: {},
  merchant_business: {},
  merchant: {},
  destination_warehouse: {},
  origin_warehouse: {},
  destination_city: {},
  origin_city: {},
  order_flags: [],
  remark: [],
  order_setting: {},
  status: {},
  admin: {},
})

export default emptyOrderPayload
